import { Extension } from '@tiptap/core';
import { TextSelection } from '@tiptap/pm/state';

const SafeSelectAll = Extension.create({
  name: 'safeSelectAll',

  addKeyboardShortcuts() {
    return {
      'Mod-a': ({ editor }) => {
        const { doc, tr } = editor.state;
        if (!doc.content.firstChild || !doc.content.lastChild) return false;

        const from = 1;
        const to = doc.content.size - 1;
        const selection = TextSelection.create(doc, from, to);
        editor.view.dispatch(tr.setSelection(selection));
        editor.view.focus();

        return true;
      },
    };
  },
});

export default SafeSelectAll;
